import { render, staticRenderFns } from "./UserExchangeList.vue?vue&type=template&id=13da14c4&scoped=true&"
import script from "./UserExchangeList.vue?vue&type=script&lang=js&"
export * from "./UserExchangeList.vue?vue&type=script&lang=js&"
import style0 from "./UserExchangeList.vue?vue&type=style&index=0&id=13da14c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da14c4",
  null
  
)

export default component.exports